'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _panelsUi = require('panels-ui');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _style = require('../style');

var _reactRedux = require('react-redux');

var _groupGetGroupId = require('../group/get-group-id');

var _groupGetGroupId2 = _interopRequireDefault(_groupGetGroupId);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var Match = function Match(props) {
  var wrapperStyle = {
    marginTop: props.i === 0 ? 75 : 30
  };
  var team2MatchContent = _extends({}, style.matchContent, {
    marginLeft: 10
  });

  var team1Name = props.teamsById[props.team1.id] ? props.teamsById[props.team1.id].name : props.team1.id;
  var team2Name = props.teamsById[props.team2.id] ? props.teamsById[props.team2.id].name : props.team2.id;

  return _react2['default'].createElement(
    'div',
    { style: wrapperStyle },
    _react2['default'].createElement(
      'div',
      { style: style.matchHeading },
      props.heading
    ),
    _react2['default'].createElement(
      'div',
      { style: style.matchContentWrapper },
      _react2['default'].createElement(
        'div',
        { style: style.matchContent },
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          team1Name
        ),
        _react2['default'].createElement(
          'div',
          { style: style.matchScore },
          props.team1.score
        )
      ),
      _react2['default'].createElement(
        'div',
        { style: team2MatchContent },
        _react2['default'].createElement(
          'div',
          { style: style.matchScore },
          props.team2.score
        ),
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          team2Name
        )
      )
    )
  );
};

exports.Match = Match;
var Fixture = function Fixture(props) {
  return _react2['default'].createElement(
    _panelsUi.Panel,
    { width: props.width, style: style.panel },
    _react2['default'].createElement(
      'h1',
      { style: style.title },
      _react2['default'].createElement(
        'span',
        null,
        props.club.name
      ),
      _react2['default'].createElement(
        'span',
        null,
        'fixture'
      )
    ),
    _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, props.sponsor, { colour: 'BLUE', style: style.sponsor })),
    props.matches.map(function (match, i) {
      return _react2['default'].createElement(Match, _extends({}, props.matchesById[match], { key: i, i: i, teamsById: props.teamsById }));
    })
  );
};

exports.Fixture = Fixture;
var style = {
  matchHeading: {
    fontSize: 14
  },
  matchContent: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flex1, _browserVendorPrefix.flexDirectionRow, _browserVendorPrefix.justifyContentSpaceBetween),
  matchContentWrapper: _extends({}, _browserVendorPrefix.flexDirectionRow, {
    marginTop: 5
  }),
  matchTeam: {
    textTransform: 'uppercase'
  },
  matchScore: {
    fontSize: 25
  },
  panel: {
    backgroundColor: _style.WHITE_TRANSPARENT_85,
    color: _style.BLUE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingBottom: 200,
    paddingLeft: 35,
    paddingRight: 35
  },
  title: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85,
    textTransform: 'uppercase'
  },
  sponsor: {
    marginTop: 25
  }
};

function mapStateToProps(state, props) {
  var tournament = state.tournaments.byId[props.tournamentId];

  return {
    club: state.tournaments.clubsById[props.tournamentId],
    matches: state.fixtures.byTournamentId[props.tournamentId],
    matchesById: state.fixtures.byId,
    sponsor: state.tournaments.sponsorsById[tournament.sponsorId],
    teamsById: state.teams.byId
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Fixture);